import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialBookUpdate from "../social_book_update";

export default GrComponentFactory.createClass({
  displayName: "ChoicePollVoteNewsfeedItem",

  propTypes: {
    resource: GrPropTypes.choicePollVoteNewsfeedResource(),
  },

  renderHeader() {
    return <span>
      voted in the <a href={this.props.resource.choiceUrl}
         className="gr-hyperlink gr-hyperlink--bold">
        Goodreads Choice Awards {this.props.resource.choiceYear}
      </a>
    </span>;
  },

  getPollNameHtml(){
    return { __html: this.props.resource.pollName.replace("Best", "Readers' Favorite") };
  },

  renderChoiceBanner() {
    return <a href={this.props.resource.choiceUrl}>
      <img className="gr-newsfeedItem__pollLogo" src={this.props.resource.badgeUrl} alt="Choice Awards" />
    </a>;
  },

  renderChoiceDetails() {
    return <div className="gr-newsfeedItem__pollDetails">
      <div className="gr-newsfeedItem__pollLabel u-marginBottomSmall">
        Nominated for <a href={this.props.resource.url} dangerouslySetInnerHTML={this.getPollNameHtml()} />
      </div>
      {this.renderChoiceBanner()}
      <div>
        <a href={this.props.resource.url} className="gr-newsfeedItem__pollCTA gr-button gr-button--choice">
          Vote Now!
        </a>
      </div>
    </div>;
  },

  render() {
    return (
      <SocialBookUpdate
        {...this.props}
        header={this.renderHeader()}
        book={this.props.resource.votedBook}
        bookBody={this.renderChoiceDetails()}
        updateDetails={null}
        includeWTR={false} />
    );
  },
});
